import { render } from "./RegisterAsMentor.vue?vue&type=template&id=055237db&scoped=true"
import script from "./RegisterAsMentor.vue?vue&type=script&lang=js"
export * from "./RegisterAsMentor.vue?vue&type=script&lang=js"

import "./RegisterAsMentor.vue?vue&type=style&index=0&id=055237db&scoped=true&lang=css"

import exportComponent from "C:\\Users\\TimSpule\\source\\repos\\peacoq\\Schaltzeit\\ScoutDB\\CisLogic.ScoutDB.UI.Esa\\app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-055237db"]])

export default __exports__